import { hashQuery, query } from '../query';
import { xposParamsMap } from '../webx';
const fullParamsKey = [
    /* 页面信息 */
    'xbiz',
    'prod_key',
    'xpsid',
    'dchn',
    // 'xspm',
    'xoid',
    /* 用户信息 */
    /* 环境信息 */
    'xenv',
    /* 路径信息 */
    'xspm_from',
    'xpsid_root',
    'xpsid_from',
    'xpsid_share',
    'xpos_from',
    'xpos_share'
];
/**
 * getNineChapterParams: 通过url参数获取九章参数
 * @param url
 * @example
 * ```js
 *  const parameters = getNineChapterParams(url)
 * ```
 */
const getNineChapterParams = (url) => {
    const collection = Object.assign({}, query(url), hashQuery(url));
    return fullParamsKey.reduce((result, key) => {
        if (collection[key]) {
            result[key] = collection[key];
        }
        else if (key !== 'xpos_from' && key !== 'xpos_share') {
            result[key] = '';
        }
        switch (key) {
            case 'xpos_from':
                if (collection['xpos_from']) {
                    /* 处理xpos_from 将其从字符串转为xpos对象 */
                    try {
                        let xposInfo = JSON.parse(decodeURIComponent(collection[key]));
                        /* xpos参数映射 */
                        xposInfo = Object.entries(xposInfo).reduce((res, [key, value]) => {
                            if (xposParamsMap[key]) { // 需要映射 进行key转换
                                res[xposParamsMap[key]] = value;
                            }
                            else {
                                res[key] = value;
                            }
                            return res;
                        }, {});
                        result['xpos_from'] = xposInfo;
                    }
                    catch (err) {
                        console.error('== 运营位参数处理失败 ==', err);
                    }
                }
                else if (collection['xspm_from']) {
                    /* 兼容xspm体系和xpos体系 特殊操作 */
                    /* 如果不存在xpos_from 却存在xspm_from 则尝试使用xspm_from来填充xpos_from */
                    try {
                        const xspm_params = collection['xspm_from'].split('.');
                        const pk = xspm_params[0];
                        const xp = xspm_params[2];
                        if (xp !== 'none') {
                            result['xpos_from'] = {
                                [xposParamsMap['prod_key']]: pk === 'none' ? '' : pk,
                                [xposParamsMap['xspm']]: xp
                            };
                        }
                    }
                    catch (err) {
                        console.error('== 处理运营位参数兼容失败 ==', err);
                    }
                    /* End 兼容xspm体系和xpos体系 特殊操作 */
                }
                break;
            case 'xspm_from':
                if (!collection['xspm_from'] && collection['xpos_from']) {
                    /* 兼容xspm体系和xpos体系 特殊操作 */
                    /* 如果不存在xspm_from 却存在xpos_from 则尝试使用xpos_from来填充xspm_from */
                    try {
                        let xposInfo = JSON.parse(decodeURIComponent(collection['xpos_from']));
                        if (xposInfo['xp'])
                            result['xspm_from'] = `${xposInfo['pk'] || 'none'}.none.${xposInfo['xp']}.${xposInfo['idx'] || 'none'}`;
                    }
                    catch (err) {
                        console.error('== 处理运营位参数兼容失败 ==', err);
                    }
                    /* End 兼容xspm体系和xpos体系 特殊操作 */
                }
                else if (collection[key])
                    result[key] = collection[key];
                break;
            case 'xpos_share':
                if (collection['xpos_share']) {
                    console.log('=== xpos_share ===', collection['xpos_share']);
                    /* 处理xpos_share 将其从字符串转为xpos对象 */
                    try {
                        let xposInfo = JSON.parse(decodeURIComponent(collection[key]));
                        /* xpos参数映射 */
                        xposInfo = Object.entries(xposInfo).reduce((res, [key, value]) => {
                            if (xposParamsMap[key]) { // 需要映射 进行key转换
                                res[xposParamsMap[key]] = value;
                            }
                            else {
                                res[key] = value;
                            }
                            return res;
                        }, {});
                        result['xpos_share'] = xposInfo;
                    }
                    catch (err) {
                        console.error('== 运营位参数处理失败 ==', err);
                    }
                }
                break;
            default:
                if (collection[key])
                    result[key] = collection[key];
                break;
        }
        return result;
    }, {});
};
export { getNineChapterParams };
